window.app = window.app || {};

(function($) {

	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#editTravInfoStep2',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/edit_traveler_information/review_changes',
			SESSION_EXPIRED: '/h/book/recallReservation'
		}

	});

	formHelper.addRule({
		form: '#editTravInfoStep2NoPayment',
		status: {
			SUCCESS: '/edit_traveler_information/review_changes'
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});	

})(jQuery);


jQuery(function($){

	$(document).on('click','.fh-js-editTravInfoStep2-submitter',function(event){
		event.preventDefault();
		$('#editTravInfoStep2, #editTravInfoStep2NoPayment').submit();
	});
});
